import { isDefined } from '@eih-netbroker/common';
import { KeyboardEvent } from 'react';
import { CodeInputEvents } from './events';

const EditKeys: Record<CodeInputEvents.Edit['key'], true> = {
  ArrowRight: true,
  ArrowLeft: true,
  Delete: true,
  Backspace: true,
  Enter: true,
};

export namespace CodeInputUtils {
  export const CODE_INPUT_TAG = 'data-code-input-id';
  export const INPUT_CHAR_REGEX = /^[a-zA-Z0-9]$/;
  export const DISALLOWED_CODE_CHARS_REGEX = /[^a-zA-Z0-9]/g;

  export function getFieldElementByIndex(container: HTMLElement, index: number): HTMLElement | null {
    return container.querySelector(`[${CODE_INPUT_TAG}="${index}"]`) as HTMLElement;
  }

  export function getActiveElement(container: HTMLElement): HTMLElement | null {
    if (isDefined(document.activeElement) && container.contains(document.activeElement)) {
      return document.activeElement as HTMLElement;
    }
    return null;
  }

  export function getIndex(element: Element | undefined | null): number | undefined {
    if (!isDefined(element)) {
      return undefined;
    }
    const id = element.getAttribute(CODE_INPUT_TAG);
    if (!isDefined(id)) {
      return undefined;
    }
    return parseInt(id);
  }

  export function isEditKey(key: string): key is CodeInputEvents.Edit['key'] {
    return EditKeys[key as CodeInputEvents.Edit['key']] === true;
  }

  export function hasModifiers(e: KeyboardEvent): boolean {
    return e.ctrlKey || e.metaKey || e.altKey;
  }

  export function sanitizeSmsCode(code: string | undefined, codeLength: number): string | undefined {
    if (!isDefined(code)) {
      return undefined;
    }
    return code.replace(DISALLOWED_CODE_CHARS_REGEX, '').slice(0, codeLength);
  }
}
